export const APIs = {
    authLogin: `api/authentication/login`,
    forgotPassword: `api/authentication/forgot-password`,
    confirmForgotPasswordReset: `api/authentication/confirm-forgot-password`,
    acceptInvitation: `api/invitation/accept-invitation`,
    acceptAdminInvitation: `api/invitation/accept-admin-invitation`,
    verifyInvitation: `api/invitation/verify-invitation`,
    sendAuthCode: `api/invitation/send-auth-code`,
    refreshJwtToken: `api/authentication/refresh-token`,
    onlineCheck: `api/authentication/online-check`,
};
//# sourceMappingURL=end-points.js.map